import axios from 'axios';

const PREFIJO="/api/Mdl/";
const CUPONES="/api/PqtTm/";

export default {
    todos(formulario){
        return axios.all([
            this.individuales(formulario),
            this.kit(formulario),
            this.cupones(formulario),
        ]);
    },
    individuales(formualrio) {
        const dto = { ndt1: formualrio.id, bdt3: true ,ndt5:2}; //id paquete
        return axios.post(`${PREFIJO}VmSlIdV`,dto);
    },
    kit(formualrio) {
        const dto = { ndt1: formualrio.id, bdt3: true ,ndt5:1}; //id paquete
        return axios.post(`${PREFIJO}VmSlIdV`,dto);
    },
    cupones(formualrio) {
        const dto = { id: formualrio.id }; //id paquete
        return axios.post(`${CUPONES}VmSlTmsP`,dto);
    }
};
